export default {
	default: 'display: inline;',
	A: '',
	ABBR: '',
	ADDRESS: 'display: block;',
	AREA: '',
	ARTICLE: 'display: block;',
	ASIDE: 'display: block;',
	AUDIO: 'display: none;',
	B: '',
	BASE: 'display: none;',
	BDI: '',
	BDO: '',
	BLOCKQUAOTE: '',
	BODY: 'display: block;',
	TEMPLATE: 'display: none;',
	FORM: 'display: block;',
	INPUT: 'display: inline-block;',
	TEXTAREA: 'display: inline-block;',
	SCRIPT: 'display: none;',
	IMG: '',
	LINK: 'display: none;',
	STYLE: 'display: none;',
	LABEL: '',
	SLOT: 'display: contents;',
	SVG: '',
	CIRCLE: '',
	ELLIPSE: '',
	LINE: '',
	PATH: '',
	POLYGON: '',
	POLYLINE: '',
	RECT: '',
	STOP: '',
	USE: '',
	META: 'display: none;',
	BLOCKQUOTE: 'display: block;',
	BR: '',
	BUTTON: 'display: inline-block;',
	CANVAS: '',
	CAPTION: 'display: table-caption;',
	CITE: '',
	CODE: '',
	COL: 'display: table-column;',
	COLGROUP: 'display: table-column-group;',
	DATA: '',
	DATALIST: 'display: none;',
	DD: 'display: block;',
	DEL: '',
	DETAILS: 'display: block;',
	DFN: '',
	DIALOG: {
		default: 'display: none;',
		open: 'display: block;'
	},
	DIV: 'display: block;',
	DL: 'display: block;',
	DT: 'display: block;',
	EM: '',
	EMBED: '',
	FIELDSET: 'display: block;',
	FIGCAPTION: 'display: block;',
	FIGURE: 'display: block;',
	FOOTER: 'display: block;',
	H1: 'display: block;',
	H2: 'display: block;',
	H3: 'display: block;',
	H4: 'display: block;',
	H5: 'display: block;',
	H6: 'display: block;',
	HEAD: 'display: none;',
	HEADER: 'display: block;',
	HGROUP: 'display: block;',
	HR: 'display: block;',
	HTML: 'display: block;direction: ltr;font: 16px "Times New Roman";',
	I: '',
	IFRAME: '',
	INS: '',
	KBD: '',
	LEGEND: 'display: block;',
	LI: 'display: list-item;',
	MAIN: 'display: block;',
	MAP: '',
	MARK: '',
	MATH: '',
	MENU: 'display: block;',
	MENUITEM: '',
	METER: 'display: inline-block;',
	NAV: 'display: block;',
	NOSCRIPT: '',
	OBJECT: '',
	OL: 'display: block;',
	OPTGROUP: 'display: block;',
	OPTION: 'display: block;',
	OUTPUT: 'unicode-bidi: isolate;',
	P: 'display: block;',
	PARAM: 'display: none;',
	PICTURE: '',
	PRE: 'display: block;',
	PROGRESS: 'display: inline-block;',
	Q: '',
	RB: '',
	RP: 'display: none;',
	RT: '',
	RTC: '',
	RUBY: '',
	S: '',
	SAMP: '',
	SECTION: 'display: block;',
	SELECT: 'display: inline-block;',
	SMALL: '',
	SOURCE: '',
	SPAN: '',
	STRONG: '',
	SUB: '',
	SUMMARY: 'display: block;',
	SUP: '',
	TABLE: 'display: table;',
	TBODY: 'display: table-row-group;',
	TD: 'display: table-cell;',
	TFOOT: 'display: table-footer-group;',
	TH: 'display: table-cell;',
	THEAD: 'display: table-header-group;',
	TIME: '',
	TITLE: 'display: none;',
	TR: 'display: table-row;',
	TRACK: '',
	U: '',
	UL: 'display: block;',
	VAR: '',
	VIDEO: '',
	WBR: ''
};
